import Region from './Region';

export default Region;



// WEBPACK FOOTER //
// ./src/components/Header/Region/index.js